import { useEffect, useState } from 'react';
import { getMetrics, getMetricsTotals } from './ReportedMetrics.service';
import { metricNames } from '@linearb/linjs-common';
import { AGGREGATION_OPTIONS } from './AggregationSelector';
import _ from 'lodash';

export const useReportedMetricsModal = () => {
  const [metrics, setMetrics] = useState();
  const [isLoadingMetrics, setIsLoadingMetrics] = useState(true);

  const fetchMetrics = async () => {
    const totals = await getMetricsTotals();
    const response = await getMetrics(totals);
    setMetrics(response);
    setIsLoadingMetrics(false);
  };

  const isSaveEnabled = modalState =>
    modalState.reportedMetric !== metricNames.REPORTED_CUSTOM &&
    !_.isEmpty(String(modalState.aggregation)) &&
    (modalState.aggregation !== AGGREGATION_OPTIONS.DISTINCT_COUNT.value ||
      (modalState.aggregation === AGGREGATION_OPTIONS.DISTINCT_COUNT.value &&
        modalState.distinctCount !== null));

  useEffect(() => {
    fetchMetrics();
  }, []);

  return {
    metrics,
    setMetrics,
    isLoadingMetrics,
    isSaveEnabled
  };
};
